exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#subnav_buffer_container{height:45px}.wrapper-main .sub-nav{background:#fff}.wrapper-main .sub-nav .sticky-element .sticky-content{box-shadow:0 2px 5px 0 rgba(84,84,84,.3);background:#fff;margin-bottom:5px}.wrapper-main .sub-nav{overflow:visible}.wrapper-main .sub-nav .sticky-content.fixed{position:fixed;top:0;left:0;right:0;background:#fff;z-index:1000}@media screen and (max-width:768px){.wrapper-main .sub-nav ul{width:100vw;display:inline-block;zoom:1;font-size:0}.wrapper-main .sub-nav ul li{width:50vw;max-width:100%!important;margin-left:0;margin-right:0}.wrapper-main .sub-nav ul li p{width:100%}.settings .wrapper-main ul.scroll-container{padding-left:10px;width:560px}}#myTab{padding-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/subnavbar/subnavbar.css
// module id = 248
// module chunks = 0